import { Notify } from 'quasar'

/** The public, anonymous-viewable link to an incident preview. */
export const previewUrl = (incidentId: string): string =>
  `${window.location.origin}/preview/${incidentId}`

/**
 * Share an incident's public preview link: the native share sheet where the browser has one
 * (Android), otherwise copy the link to the clipboard and confirm with a notification.
 */
export function useShare() {
  async function copyLink(url: string): Promise<void> {
    try {
      await navigator.clipboard.writeText(url)
    } catch (error) {
      console.error('Failed to copy share link:', error)
      Notify.create({ type: 'negative', message: 'Could not copy the link' })
      return
    }
    Notify.create({ type: 'positive', message: 'Link copied' })
  }

  async function shareIncident(incidentId: string): Promise<void> {
    const url = previewUrl(incidentId)
    if (typeof navigator.share !== 'function') return copyLink(url)

    try {
      await navigator.share({ title: 'RoadFootage incident', url })
    } catch (error) {
      // Dismissing the sheet is the user's choice, not a failure.
      if (error instanceof DOMException && error.name === 'AbortError') return
      console.error('Native share failed, copying link instead:', error)
      return copyLink(url)
    }
  }

  return { shareIncident }
}
